import React, { useCallback } from 'react'
import { Redirect } from 'react-router-dom'
import { usePermissionControl } from '@/bizComponents/PermissionControl'

export interface PermissionRouteConfig {
  /** 权限code，可以传入单个权限和多个权限编码，逗号分割 */
  permissionCode?: string
  path: string
}

const authorityComponent = () => <Redirect to="/authority" />

/** 权限拦截器 */
export function usePermission() {
  const hasPermission = usePermissionControl()
  return useCallback(
    (route: PermissionRouteConfig) => {
      const { permissionCode } = route
      if (!permissionCode) return route
      return hasPermission(permissionCode)
        ? route
        : {
            ...route,
            component: authorityComponent,
          }
    },
    [hasPermission]
  )
}
